import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { Area } from 'src/app/shared/interfaces/area.interface';
import { AreaService } from '../area.service';

@Component({
  selector: 'app-area-view',
  templateUrl: './area-view.component.html',
  styleUrls: ['./area-view.component.css'],
})
export class AreaViewComponent implements OnInit {
  area: Area;
  constructor(
    private activeRouter: ActivatedRoute,
    private areaService: AreaService,
    private toastr: ToastrService,
    private router: Router,
    private location: Location,
    private loadService: LoaderService
  ) {
    this.activeRouter.params.subscribe((params: Params) => {
      if (params.id) {
        this.getArea(params.id);
      }
    });
  }

  ngOnInit(): void {}

  getArea(id: number): Promise<void> {
    this.loadService.showLoader();
    return this.areaService
      .getById(id)
      .then((res) => {
        this.area = res;
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.toastr.error(err.error.message);
        this.loadService.closeLoader();
      });
  }

  back(): void {
    this.location.back();
  }
}
